export default (state = null) => state



// WEBPACK FOOTER //
// ./state/reducers/CMT/Realm.js